
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';
import i18n from '@/locales';
@Component
export class SubscriptionTableMix extends Vue {
    get SubscriptionColumns(): ITableColumn[] {
        return [
            {
                title: i18n.t('certificate.number') as string,
                dataIndex: 'membership_number',
                key: '0'
            },
            {
                title: i18n.t('loyalty.type') as string,
                dataIndex: 'type.name',
                key: '1'
            },
            {
                title: i18n.t('loyalty.faceValue') as string,
                dataIndex: 'sum',
                key: '2'
            },
            {
                title: i18n.t('certificate.activationDate') as string,
                dataIndex: 'type.created_at',
                key: '3',
                scopedSlots: {
                    customRender: 'activeFrom',
                },
            },
            {
                title: i18n.t('certificate.deactivationDate') as string,
                dataIndex: 'type.updated_at',
                key: '4',
                scopedSlots: {
                    customRender: 'activeTo',
                },
            },
            {
                title: i18n.t('certificate.status') as string,
                dataIndex: 'status',
                key: '5',
                scopedSlots: {
                    customRender: 'status',
                },
            },
        ];
    }
    get columnsCard(): ITableColumn[] {
        return [
            {
                title: '#',
                dataIndex: 'pivot[id]',
                key: '0'
            },
            {
                title: i18nText("Дата"),
                dataIndex: 'transaction_date',
                key: '1',
                /*scopedSlots: {
                    customRender: 'date_create'
                }*/
            },
            {
                title: i18nText("Тип"),
                dataIndex: 'service_name',
                key: '2'
            },
            {
                title: i18nText("Студия"),
                dataIndex: 'salon_id',
                key: '3'
            },
            {
                title: i18nText("Сумма"),
                dataIndex: 'service_price',
                key: '4'
            },
        ];
    }
}
